import type { FaireProductEntity } from "../../entity_types/product";

export const p_bzwqmdzfwg: FaireProductEntity = {
  token: "p_bzwqmdzfwg",
  type: "product",
  name: "IT2594-GRINCHYMERRY  'GRINCHY & MERRY' Reversible Sweatshirt",
  brandToken: "b_4o95d3k7hq",
  brandName: "BUCKETLIST INC",
  imageUrl:
    "https://cdn.faire.com/fastly/9b8c3b770393aef0d4e68801dcdeae52da315c603dd7d9bd7fbde41fc963b59b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/14f0a8eae0c781d25b2eb9f169db6abeb7a3f95df66f6ff8359f8f9fc3e52729.jpeg",
  ],
  priceDollars: 27.95,
  description:
    "'GRINCHY & MERRY' Print Reversible Mock Neck Sweatshirt\n- Mock-neck \n- Drop shoulder, long sleeves\n- Softest cozy fleece\n- Oversized fit\n- Rib banded hemline and cuffs\n- The reversible design lets you switch up your style.\n- 'GRINCHY' lettering print on one side\n- 'MERRY' lettering print on the inside\n\n** The pants made with the same fabric as this design, and that can be worn as a set, are styles IP5425-2 & IP5729 **",
  tags: [],
  msrpDollars: 55.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:28.149Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
